/* CUSTOM 2026-08-05 — Fuellstand im Warenkorb-Symbol des Headers.

   Beim Seitenaufruf setzt Liquid den Stand bereits richtig (siehe
   snippets/custom-icon-cart-fill.liquid). Diese Datei kuemmert sich um alles danach: Der Shop
   legt Artikel per AJAX in den Warenkorb, die Seite laedt dabei nicht neu.

   Angebunden wird die theme-eigene Ereignisverteilung (theme.pubsub, PUB_SUB_EVENTS.cartUpdate) —
   dieselbe Quelle, aus der auch der Zaehler neben dem Symbol seinen Wert bezieht. Damit laufen
   Zahl und Symbol garantiert synchron, statt dass zwei Mechanismen nebeneinanderher arbeiten.

   Ein MutationObserver auf <cart-count> dient als Rueckfall, falls das Theme den Header per
   Section Rendering API neu zeichnet und dabei nicht ueber pubsub geht.
*/
(() => {
  if (window.__customCartFill) return;
  window.__customCartFill = true;

  /* CUSTOM 2026-08-14 — Drei statt vier Staende. Die gelieferten Zeichnungen
     (ngb-einkaufswagen-1 bis -4) gehen von leer bis drei Pakete; einen vierten Stand gibt es
     nicht. Muss zum `at_most` in snippets/custom-icon-cart-fill.liquid passen, sonst zeigt der
     erste Seitenaufruf einen anderen Stand als jede spaetere Aenderung. */
  const MAX_PAKETE = 3;

  /* CUSTOM 2026-08-07 — ALLE Vorkommen, nicht nur das erste.
     Das Symbol sitzt inzwischen auch im Kaufen-Knopf der Sticky-Leiste auf der Produktseite.
     Mit querySelector wurde dort nie etwas gesetzt oder animiert — der Warenkorb im Header
     fuellte sich, der in der Leiste blieb leer. */
  const symboleHolen = () => [...document.querySelectorAll('[data-cart-fill]')];

  /* Wird nur bei einer ECHTEN Erhoehung abgespielt. Beim Entfernen eines Artikels soll das
     Symbol still umschalten — eine Jubel-Animation waere dort das falsche Signal. */
  const animieren = (symbol, gestiegen) => {
    if (!gestiegen) return;

    symbol.classList.remove('cart-fill--bump');
    /* Reflow erzwingen, sonst startet dieselbe Animation beim zweiten Mal nicht neu. */
    void symbol.getBoundingClientRect();
    symbol.classList.add('cart-fill--bump');

    const paket = symbol.querySelector(
      `.cart-fill__pack--${symbol.getAttribute('data-count')}`
    );

    if (paket) {
      paket.classList.remove('cart-fill__pack--pop');
      void paket.getBoundingClientRect();
      paket.classList.add('cart-fill__pack--pop');
    }
  };

  /* CUSTOM 2026-08-06 — Zaehler ab 100 auf "99+" kappen.
     Liquid setzt den Anfangswert bereits gekappt (snippets/header-icons.liquid); theme.js
     schreibt bei jeder Warenkorb-Aenderung aber die rohe Zahl zurueck
     (CartCount.onCartUpdate). Ohne diese Nachbesserung stuende nach dem ersten Hinzufuegen
     wieder z. B. "1748" im Symbol.
     Der Wachhund weiter unten beobachtet denselben Knoten — deshalb die Wiedereintritts-Sperre,
     sonst loest das eigene Schreiben den Beobachter erneut aus. */
  let kappenLaeuft = false;

  const zaehlerKappen = (anzahl) => {
    const zaehler = document.querySelector('cart-count');
    if (!zaehler || kappenLaeuft) return;

    const zahl = parseInt(anzahl, 10);
    if (!Number.isFinite(zahl)) return;

    const anzeige = zahl > 99 ? '99+' : String(zahl);
    if (zaehler.textContent.trim() === anzeige) return;

    kappenLaeuft = true;
    zaehler.textContent = anzeige;
    kappenLaeuft = false;
  };

  const setzen = (anzahl) => {
    symboleHolen().forEach((symbol) => setzenAn(symbol, anzahl));
  };

  const setzenAn = (symbol, anzahl) => {
    if (!symbol) return;

    const neu = Math.min(Math.max(parseInt(anzahl, 10) || 0, 0), MAX_PAKETE);
    const alt = parseInt(symbol.getAttribute('data-count'), 10) || 0;

    /* Auch bei gleichem Fuellstand animieren, solange der Warenkorb tatsaechlich gewachsen ist:
       ab dem fuenften Artikel bleibt das Bild bei vier Paketen stehen, eine Rueckmeldung auf den
       Klick soll es trotzdem geben. Deshalb wird die echte Artikelzahl mitgefuehrt. */
    const echtAlt = parseInt(symbol.getAttribute('data-items'), 10) || 0;
    const echtNeu = parseInt(anzahl, 10) || 0;

    symbol.setAttribute('data-count', neu);
    symbol.setAttribute('data-items', echtNeu);

    animieren(symbol, echtNeu > echtAlt);

    /* alt wird nur fuer die Lesbarkeit oben gebraucht; bewusst ohne weitere Verwendung. */
    void alt;
  };

  const anbinden = () => {
    const zaehlerStart = document.querySelector('cart-count');
    symboleHolen().forEach((symbol) => {
      if (symbol.hasAttribute('data-items')) return;
      symbol.setAttribute('data-items', zaehlerStart ? parseInt(zaehlerStart.innerText, 10) || 0 : 0);
    });

    /* Hauptweg: die Ereignisverteilung des Themes. */
    if (window.theme?.pubsub?.subscribe && window.theme.pubsub.PUB_SUB_EVENTS?.cartUpdate) {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (ereignis) => {
        if (!ereignis?.cart || ereignis.cart.errors) return;
        setzen(ereignis.cart.item_count);
        zaehlerKappen(ereignis.cart.item_count);
      });
    }

    /* Rueckfall: auf Aenderungen des sichtbaren Zaehlers reagieren. */
    const zaehler = document.querySelector('cart-count');
    if (zaehler) {
      new MutationObserver(() => {
        setzen(zaehler.innerText);
        zaehlerKappen(zaehler.innerText);
      }).observe(zaehler, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anbinden);
  } else {
    anbinden();
  }
})();
